import React, {useEffect, useState} from 'react';
import {
    AppBar,
    ButtonResponsive,
    CustomListItem,
    FilteredAlert,
    ListViewMode,
    LoadingProgress,
    MostrarError,
    Pagination,
    PlusFab,
    SeacrhAppBar,
    TableSort
} from "../../components";
import {mostrarGastos} from '../../redux/reducers/gastoReducers';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TableBody,
    TableCell,
    TableFooter,
    TableRow,
    TextField,
    Theme,
    Typography,
    useMediaQuery
} from "@mui/material";
import Strings from "../../assets/strings"
import {useLocation, useNavigate} from "react-router-dom";
import {formatDate, formatPeso, hasPermissionTo, PERSMISOS} from "../../helpers";
import {SelectAgente, SelectCaja, SelectUsoMultiples} from "../../components/selects";
import DetallesGasto from "./detallesGasto";
import Crear from "./crear";
import {FilterList} from "@mui/icons-material";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IGastoFilter} from "../../redux/types/IGasto";
import TopBarDialog from "../../components/topBar/TopBarDialog";

const initialState:IGastoFilter={
    name:'',
    creadoPor: undefined,
    cajaId:undefined,
    categoriaId:undefined,
    fechaDesde: '',
    fechaHasta: '',
    incluirAnulados:false,
    page: 1,
    pageSize: 15,
    orderBy: "",
    orderByIsDescending:undefined,
};

function  Gastos() {
    const smVewport = useMediaQuery((theme:Theme) =>theme.breakpoints.down('md'));
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {state:urlState, pathname} = useLocation();

    const { list, status, error,filtered } = useAppSelector(state=>state.gastos);
    const viewTableList = useAppSelector(state=>state.theme.viewTableList);


    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState(initialState);

    const isEmpty = list?.items.length === 0;


    useEffect(() => {
        dispatch(mostrarGastos());
    }, [dispatch]);
    //set filtered params
    useEffect(()=>setFilter({...initialState,...filtered}),[setFilter,filtered])



    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>)=>{
        const {name, value, checked} = e.target;
        if(name === "name" || name === "page" || name === "pageSize") return  dispatch(mostrarGastos({...filter,page:1,[name]:value}));

        if(name === "incluirAnulados")
            setFilter({...filter,page:1, incluirAnulados:!!checked});
        else
            setFilter({...filter,page:1,[name]:value});
    };
    const resetFilter = () => {
        setOpenFilter(false);
        dispatch(mostrarGastos({}));
    };
    const searchFilter = () => {
        setOpenFilter(false);
        dispatch(mostrarGastos(filter));
    };
    const tableSortProps = (orderBy:string) => {
        return {
            active:filter.orderBy === orderBy,
            direction: filter.orderByIsDescending ? "desc" : 'asc',
            onClick:()=> mostrarGastos({...filter,page:1, orderBy, orderByIsDescending: !filter.orderByIsDescending})
        }
    };



    return <>
        <AppBar />
        <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} maxWidth={"xs"} >
            <TopBarDialog title={Strings.filtrar} onClose={()=>setOpenFilter(false)} light/>

            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={6} >
                        <TextField
                            label={Strings.fechaDesde}
                            type="date"
                            name="fechaDesde"
                            value={filter.fechaDesde}
                            onChange={handleFilter}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={6} >
                        <TextField
                            label={Strings.fechaHasta}
                            type="date"
                            name="fechaHasta"
                            value={filter.fechaHasta}
                            onChange={handleFilter}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <SelectAgente
                            label={Strings.creadoPor}
                            value={filter.creadoPor?filter.creadoPor:undefined}
                            onChange={handleFilter}
                            name="creadoPor"
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <SelectUsoMultiples
                            group="1"
                            name="categoriaId"
                            value={filter.categoriaId}
                            onChange={handleFilter}
                            label={Strings.categoria}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectCaja
                            name= 'cajaId'
                            value={filter.cajaId}
                            allowAll
                            onChange={handleFilter}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            sx={{m:0}}
                            control={<Checkbox checked={filter.incluirAnulados} onChange={handleFilter} name="incluirAnulados" />}
                            label={Strings.ver+" "+Strings.anulado}
                            labelPlacement="start"
                        />
                    </Grid>
                </Grid>
                <br/>
            </DialogContent>
            <DialogActions>
                <Button onClick={resetFilter} color={"warning"} size={"small"} sx={{textTransform:"capitalize"}}>
                    {Strings.restablecer}
                </Button>
                <Button color="primary" onClick={searchFilter} variant={"outlined"}>
                    {Strings.filtrar}
                </Button>
            </DialogActions>
        </Dialog>

        <section className="contentInner" style={(status === "loading")?{opacity:.8}:{opacity:1}}>
            {(status === "loading") && <LoadingProgress vh/>}
            {!urlState && <MostrarError errors={error}/>}

            <ListViewMode pageRows={list?.pageSize} pageTotalRows={list?.totalCount}>
                <SeacrhAppBar name="name" value={filter.name} onChange={handleFilter}/>
                <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(true)}/>
                {/*<ButtonResponsive icon={<CloudDownloadOutlined/>} text={Strings.exportar} disabled={isEmpty} onClick={()=>downloadFiles(filter,"gastos")}/>*/}
                <FilteredAlert onClose={resetFilter} filter={filtered}/>
            </ListViewMode>
            {(!viewTableList && smVewport)?(
                list?.items.map(item =>
                    // @ts-ignore
                 <CustomListItem
                      key={item.id} onClick={()=>navigate(pathname,{state:{detalleGasto:item}})}
                      lt={item.concepto}
                      lb={<Typography variant="caption">{item.categoria}</Typography>}
                      rt={<Typography color={"primary"}>{formatPeso(item.monto)}</Typography>}
                      rb={<Typography variant="caption">{formatDate(item.fecha)}</Typography>}
                 />
                )
            ):(

                <TableSort data={[
                    {pro:"fecha",text:Strings.fecha},
                    {pro:"monto",text:Strings.monto},
                    {pro:"concepto",text:Strings.concepto},
                    {pro:"categoriaId",text:Strings.categoria},
                    {pro:"caja",text:Strings.cajas},
                    // {pro:"creadoPor",text:Strings.creadoPor},
                    {pro:"comentario",text:Strings.comentario},
                ]} onSort={tableSortProps} lessVh={144}>
                    <TableBody>
                    {list?.items.map(item =>
                        <TableRow
                            key={item.id}
                            className={!!item.fechaAnulacion ? "text-red-deep":""}
                            onClick={()=>navigate(pathname,{state:{detalleGasto:item}})}
                        >
                            <TableCell> {formatDate(item.fecha)}</TableCell>
                            <TableCell> {formatPeso(item.monto)}</TableCell>
                            <TableCell> {item.concepto}</TableCell>
                            <TableCell>{item.categoria}</TableCell>
                            <TableCell> {item.caja}</TableCell>
                            {/*<TableCell> {item.creadoPor}</TableCell>*/}
                            <TableCell className="comment">{item.comentario}</TableCell>

                        </TableRow>
                    )}
                    </TableBody>
                    {!isEmpty &&
                    <TableFooter>
                        <TableRow>
                            <TableCell><Typography align={"right"}>Total:</Typography> </TableCell>
                            <TableCell>{formatPeso(list?.footer?.monto??0)}</TableCell>
                            <TableCell colSpan={4} />
                        </TableRow>
                    </TableFooter>
                    }
                </TableSort>
            )}
            {list &&
                <Pagination
                    empty={Boolean(isEmpty && (status === "loading"))}
                    count={list.totalCount || 0}
                    rowsPerPage={filter.pageSize??15}
                    page={list.pageNumber - 1}
                    onPageChange={(e, page) => {
                        dispatch(mostrarGastos({...filter,page:page + 1}));
                    }}
                    onRowsPerPageChange={handleFilter}
                />
            }
            {hasPermissionTo(PERSMISOS.gastosCrear) &&
                <>
                    <PlusFab component={Button} onClick={()=>navigate(pathname,{state:{id:""}})} />
                    <Crear/>
                </>
            }
        </section>
        <DetallesGasto allowDelete />
    </>;


}

export default Gastos
